var map = {
	"./25golesChampions.jpg": 15033,
	"./60transferValue.jpg": 56772,
	"./7golesMundo.jpg": 25468,
	"./african_player.jpg": 46733,
	"./asian_player.jpg": 88622,
	"./balon_oro.jpg": 26240,
	"./bota_oro.jpg": 75071,
	"./campeon_mundo.jpg": 82461,
	"./champions.jpg": 76652,
	"./concacaf_player.jpg": 71505,
	"./conference_league.jpg": 29596,
	"./copa_america.jpg": 93302,
	"./copa_argentina.jpg": 36260,
	"./eurocopa.jpg": 9042,
	"./europa_league.jpg": 38146,
	"./goldenboy.jpg": 67479,
	"./jjoo.jpg": 81671,
	"./nations_league.jpg": 39099,
	"./premier_league.jpg": 10905,
	"./puskas.jpg": 8750,
	"./triplete.jpg": 52525
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59619;